import {Typography} from '@mui/material';
import Box from '@mui/material/Box';
import {styled} from '@mui/material/styles';

import MuiModal from 'components/modal/Modal';

export const UpchargeContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingTop: theme.spacing(1),
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  paddingBottom: theme.spacing(1),
  borderRadius: theme.spacing(1),
  background: theme.palette.common.mds_global_color_orange_20
}));

export const InfoIconWrapper = styled(Box)(({theme}) => ({
  display: 'flex',
  marginRight: theme.spacing(2)
}));

export const StyledTypography = styled(Typography)(({theme}) => ({
  fontSize: theme.spacing(2),
  lineHeight: 'normal',
  letterSpacing: theme.spacing(0.04),
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(1.75)
  }
}));

export const StyledModal = styled(MuiModal)(({theme}) => ({
  '.MuiPaper-root': {
    margin: theme.spacing('auto', 2),
    maxWidth: '100%',
    [theme.breakpoints.up('desktop')]: {
      margin: theme.spacing('auto', 4),
      maxWidth: theme.spacing(96)
    }
  },

  '.MuiDialogContent-root': {
    padding: 0
  }
}));
